import { useApiStore } from '@/stores/api.js'
import { toast } from '@/composables/toast.js'
import AppRouter from '@/router.js'
import { ref } from 'vue'
import AppI18n from '@/i18n.js'

export const useFetch = (method, url, body = null, headers = {}, options = {}) => {
  const mainHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }

  if (useApiStore().token) {
    mainHeaders['Authorization'] = `Bearer ${useApiStore().token}`
  }

  return fetch(url, {
    method,
    body: body ? JSON.stringify(body) : null,
    headers: Object.assign({}, mainHeaders, headers),
  }).then(resp => {
    if (resp.ok) {
      return resp.json()
    } else if (resp.status === 401) {
      useApiStore().token = null
      useApiStore().role = null
      AppRouter.push('/auth/login')
    }
    return resp
  }).then(resp => {
    if (resp.hasOwnProperty('success')
      && !resp.success
      && !options.quiet
      && !resp.options?.quiet) {
      toast(AppI18n.global.t(`errors.${resp.message?.toLowerCase()}`), { type: 'error' })
    }
    return resp
  })
}

export const useAsyncRequest = (minimumDuration = 750, quiet = false) => {
  const loading = ref(false)
  let activeRequests = 0

  async function call(fn) {
    if (!quiet) {
      activeRequests++
      loading.value = true
    }

    const start = Date.now()

    try {
      return await fn()
    } finally {
      const elapsed = Date.now() - start
      const remaining = minimumDuration - elapsed
      await new Promise(resolve => setTimeout(resolve, Math.max(0, remaining)))

      if (!quiet) {
        activeRequests--
        if (activeRequests === 0) {
          loading.value = false
        }
      }
    }
  }

  return { loading, call }
}

export const throttle = (fn, limit) => {
  let lastCall = 0
  return (...args) => {
    const now = Date.now()
    if (now - lastCall >= limit) {
      lastCall = now
      fn(...args)
    }
  }
}
